import type {ChangedDocumentService, RouterService} from '@formbird/services';
import { ClientConfig } from '@formbird/types';

export const changedDocumentService: ChangedDocumentService = (window as any).FormbirdServiceInjector.get('ChangedDocumentService');
export const routerService: RouterService = (window as any).FormbirdServiceInjector.get('RouterService');
export const documentModalService = (window as any).FormbirdServiceInjector.get('DocumentModalService');

export const configService = {
    clientConfig: <T>(): ClientConfig & T => {
        return (window as any).ftClientConfig;
    }
};

// taken from formbird-sc-components/projects/formbird-sc-shared/src/lib/scl-util-url.service.ts
export const UrlService = {
    openLink(link: string, mode?: string, componentScope?: any) {
        const openMode = mode ?? 'currentWindow';
        switch (openMode) {
            case 'currentWindow' :
                routerService.navigateByUrl(link)
                break;

            case 'newWindow':
                window.open(link, '_blank');
                break;

            case 'popup' :
                window.open(link, undefined, 'height=300,width=600');
                break;

            case 'overlay':
                const documentId = this.getDocIdFromLink(link);
                componentScope.selectedDocumentId = documentId;
                documentModalService.openDocumentInModal(documentId, componentScope);
                break;

            case 'noDisplay' :
                break;
            default :
                routerService.navigateByUrl(link)
                break;
        }
    },
    getDocIdFromLink(link: string) {
        const lstIdx = link.lastIndexOf('/');
        if (!link || lstIdx === -1) {
            return null;
        } else {
            return link.substr(lstIdx + 1, link.length);
        }
    }

}
